module.exports = __webpack_public_path__ + "static/media/signage-indoor-img7.d60c8f18.jpg";